<template>
  <span>
    <template v-for="(t, index) in computedValue">
      <tag
        :key="index"
        :ask-before-removing="askBeforeRemoving"
        :tooltip="tooltipFor(t, index)"
        :value="textFor(t, index)"
        :deletable="deletable && deletableFor(t, index)"
        :variant="variantFor(t, index)"
        :class="{ 'mr-1': index < computedValue.length - 1 }"
        @click="$emit('click', t, index)"
        @remove="remove(t, index)"
      />
    </template>
  </span>
</template>
<script>
import { sortBy } from 'lodash';

export default {
  props: {
    askBeforeRemoving: {
      type: Boolean,
      default: false
    },

    deletable: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Array,
      default: () => []
    },

    ordered: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    computedValue() {
      if (this.ordered) {
        return sortBy(this.value, v => this.textFor(v));
      } else {
        return this.value;
      }
    }
  },

  methods: {
    deletableFor(v /*, index*/) {
      if (typeof v === 'string') {
        return false;
      }

      return v.deletable;
    },

    textFor(v /*, index*/) {
      if (typeof v === 'string') {
        return v;
      }

      return v.text;
    },

    variantFor(v /*, index*/) {
      if (typeof v === 'string') {
        return 'primary';
      }

      return v.variant || 'primary';
    },

    tooltipFor(v /*, index*/) {
      if (typeof v === 'string') {
        return undefined;
      }

      return v.help;
    },

    classFor(v, index) {
      const ret = {
        'badge': true,
        'mr-1': index < this.value.length - 1
      };

      ret['badge-' + this.variantFor(v, index)] = true;

      return ret;
    },

    remove(v /*, index*/) {
      //if (confirm('Vuoi veramente rimuovere il tag?')) {
        const value = this.value.filter(x => x !== v);
        this.$emit('input', value);
      //}
    }
  }
};
</script>
